import APIv2 from "./_apiv2";
import {MVEditor} from "./_multi-value-editor";


const ListMultiSelectEditor = {
    entriesLists: {
        // "field": []
    },
    
    qSelectors: {
        wrapper: "[data-list-field-rw]",
        btnEnable: "button[data-enable-field-editor]",
        btnSave: "button[data-field-editor-save]",
        btnClose: "button[data-close-field-editor]",
    },
    
    renderAll(){
        this.someEvents();
        
        let $selectors = $("[data-connection]:not([data-connection='init'])");
        
        if($selectors.length === 0) return;
        
        $selectors.each( (key, element) => {
            this.renderForTag(element)
        })
    },
    
    renderForTag(element, options = {}, params = {}){
        let $editorElWrapper;
        if(params.wrapper){
            $editorElWrapper = params.wrapper;
        } else {
            $editorElWrapper = $(element).closest(ListMultiSelectEditor.qSelectors.wrapper);
        }
        
        const field = $editorElWrapper.data('field');
        if(! ListMultiSelectEditor.entriesLists[field]) {
            ListMultiSelectEditor.entriesLists[field] = [];
        }

        let createOption = false;
        
        let createItemURI = $editorElWrapper.data('create');
        if(createItemURI){
            createOption = function (name, callback) {

                window['APIv2']._request(createItemURI, {
                    name: name,
                    workspace_id: window['APIv2'].workspace.id,
                }, 'POST').then((data) => {
                    // Append new option to the cache-list
                    ListMultiSelectEditor.entriesLists[field].push(data.entry);


                    // Clean old cache for other selectized lists
                    element.selectize.clearOptions()

                    // End inner logic
                    callback(data.entry ? data.entry : data.connection);
                })
            }
        }
        
        options = $.extend({
            placeholder: "",
            plugins: ['remove_button'],
            preload: 'focus',
            valueField: 'id',
            labelField: 'name',
            searchField: 'name',
            sortField: [{
                field: 'contacts_amount',
                direction: 'desc'
            }, {
                field: 'name',
                direction: 'asc'
            }],
            dropdownParent: 'body',
            create: createOption,
            load(query, callback){
                if(query.length > 0){
                    return [];
                }

                if(typeof ListMultiSelectEditor.entriesLists[field] !== "undefined" && ListMultiSelectEditor.entriesLists[field].length){
                    callback([ListMultiSelectEditor.entriesLists[field]]);
                } else {
                    window['APIv2']._request('data-directory', {
                        query: query,
                        workspace_id: window['APIv2'].workspace.id,
                    }).then((data) => {
                                              console.log(field, data);  
                        ListMultiSelectEditor.entriesLists[field] = data.directory[field];
                        callback([ListMultiSelectEditor.entriesLists[field]]);
                    }).catch((err) => {console.log(err)})
                }
            },
            /*onItemAdd(value, $item){
                console.log('selected added:', value, $item)
            },*/
            onChange(value){
                
            }

        }, options);
        
        $(element).selectize(options);
    },

    updateOriginalViewIfInTable(selectizeInst, entryId, callback = null){
        const $editorElWrapper = selectizeInst.$control.closest(ListMultiSelectEditor.qSelectors.wrapper);
        if($editorElWrapper.length > 0){
            
            const field = $editorElWrapper.data('field');
            
            let $originalPart = $editorElWrapper.find('.inline-original');
            
            $.post('/api/v1/editable/original', {
                id: entryId,
                multiselect: true,
                field: field
            }, function (response) {
                $originalPart.find('.preview').html(response);
                
                if(callback){
                    callback();
                }
            });
        }
    },
    
    mode($editorElWrapper, mode){
        const field = $editorElWrapper.data('field');
        let $editorPart = $editorElWrapper.find('.inline-editor');
        let $originalPart = $editorElWrapper.find('.inline-original');
        
        $originalPart.toggleClass('d-none', (mode === 'editor'));
        $editorPart.toggleClass('d-none', (mode === 'preview'));

        if(mode === 'preview'){


            $.post('/api/v1/editable/editor', {
                id: $editorElWrapper.data('id'),
                multiselect: true,
                field: field
            }, (response) => {
                $editorPart.find('.edit-select-wrap').html(response);

                $editorPart.find(this.qSelectors.btnClose).off('click');
                $editorPart.find(this.qSelectors.btnSave).off('click');
            });
            
        } else {

            $editorPart.find(this.qSelectors.btnSave).prop("disabled", false);
            $editorPart.find(this.qSelectors.btnSave).removeClass('oc-loading');
            
            $editorPart.find(this.qSelectors.btnClose).one('click', () => {
                this.mode($editorElWrapper, 'preview');

                if($editorPart.find(`[data-${field}].selectized`).length > 0){
                    $editorPart.find(`[data-${field}].selectized`)[0].selectize.destroy();
                }
                
            });
            
            $editorPart.find(this.qSelectors.btnSave).one('click', () => {
                
                let element = $editorPart.find(`[data-${field}].selectized`)[0];
                let selectizeInst = element.selectize;

                $editorPart.find(this.qSelectors.btnSave).prop("disabled", true);
                $editorPart.find(this.qSelectors.btnSave).addClass('oc-loading');
                
                $.request('onBulkAction', {
                    data: {
                        action: "edit",
                        ids: element.dataset.id,
                        field: field,
                        value: selectizeInst.getValue()
                    },
                    complete: function () {

                        //selectizeInst.destroy();
                        
                        ListMultiSelectEditor.updateOriginalViewIfInTable(selectizeInst, element.dataset.id, function () {
                            ListMultiSelectEditor.mode($editorElWrapper, 'preview');
                        });

                        this.complete();
                    }
                })

                
            });
            
            
            this.renderForTag($editorPart.find(`select[data-${field}]`)[0]);
        }
    },
    someEvents()
    {
        $(`${this.qSelectors.wrapper}:not(.ie-init)`)
            .on('dblclick', (evt) => {
                $(evt.currentTarget).find(this.qSelectors.btnEnable).trigger('click')
            })
            .addClass('ie-init');
        
        $(`${this.qSelectors.btnEnable}:not(.ie-init)`)
            .on('click', (evt) => {
                if(! $(evt.currentTarget).closest(this.qSelectors.wrapper).hasClass('d-none')){
                    ListMultiSelectEditor.mode($(evt.currentTarget).closest(this.qSelectors.wrapper), 'editor')
                }
            })
            .addClass('ie-init');
        
    }
}

export { ListMultiSelectEditor };
